import { FormProvider, useForm, useWatch } from "react-hook-form";
// import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";

// import FullScreenLayout from "../../../layout/fullScreen/fullScreen";

import { useState, useEffect, useCallback } from "react";
import images from "../../../assets/images";
import "./form-parser.scss";
import TabBar from "../../tabs/tabs";
import formBuilderDeConversion from "../../../utils/form-builder-deconversion";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import dayjs from "dayjs";
import { SECTION_TYPES } from '../../../utils/constant';
import { CountryData } from 'react-phone-input-2';
import Alert from '../../alert/alert';
import _ from "lodash";
import { useTranslation } from "react-i18next";
import FormSection from "./form-section";
const validationReducer = (validations: any, validation: any, field: any, translationFn: any) => {
  switch (validation.type) {
    case "required":
      return (field.field_properties?.is_multiselect ? validations.required(translationFn(validation.msg_en)).min(1, translationFn(validation.msg_en)) : validation.value
        ? validations.required(translationFn(validation.msg_en)).test('not-empty', translationFn(validation.msg_en), value => typeof value === 'string' ? value && value?.trim()?.length > 0 : true) : validations.nullable());
    case "min_length":
      return validations.min(validation.value, translationFn(validation.msg_en));
    case "max_length":
      return validations.max(validation.value, translationFn(validation.msg_en));
    case "min_val":
      return validations.min(validation.value, translationFn(validation.msg_en));
    case "max_val":
      return validations.max(validation.value, translationFn(validation.msg_en));
    case "postive_number":
      return validations.test('is-positive-number', translationFn(validation.msg_en), (value) => value >= 0)
    case 'email':
      return validations.email(validation.msg_en);
    case "no_special_char":
      return validations.test(
        "no-special-char",
        translationFn(validation.msg_en),
        value =>
          typeof value === "string"
            ? /^[^.\-\W_]+$/u.test(value) // allow letters/digits only
            : true
      );
    case "matches":
      return validations.matches(new RegExp(validation.value), { excludeEmptyString: true, message: translationFn(validation.msg_en) });
    case "when":
      return validations.when(validation.relation, {
        is: (val: any) => val === validation.values,
        then: () => validation?.thenValidations?.reduce(
          (validations: any, validation: any) => validationReducer(validations, validation, field, translationFn),
          validations
        ) || validations,
        otherwise: () => validation?.otherWiseValidations?.reduce(
          (validations: any, validation: any) => validationReducer(validations, validation, field, translationFn),
          validations
        ) || validations,
      });
    // Add more cases for other validation types as needed
    default:
      return validations;
  }
}

const FormParser = ({
  data,
  defaultValues,
  handleFormSubmit,
  fieldArrayName,
  mode,
  displayAvtar = false,
  onTableAddClick,
  handleFormValues,
  getFormMethods,
  setFields,
  onSelectFooterClick,
  setActiveTabValue,
  activeTab = 0,
  recieveTabDataLenght,
  recieveIsValidForm,
  activeTabs,
  onTableCellChange,
  containerStyles = undefined,
  isButton = true,
  getSelectedData,
  refreshOptions = false,
  onBlur,
}: any) => {

  const { t } = useTranslation();

  function convertToNestedObject(dotNotationString: string, field: any, existingObject: any = {}) {
    const keys = dotNotationString.split('.');
    let currentLevel = existingObject;

    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        if (!currentLevel[key]) {
          const fieldValidations = field.validation.reduce(
            (validations: any, validation: any) => {
              switch (validation.type) {
                case "required":
                  return validation.value
                    ? validations.required(t(validation.msg_en)).test('not-empty', t(validation.msg_en), value => typeof value === 'string' ? value && value?.trim()?.length > 0 : true)
                    : (field.field_properties?.is_multiselect ? validations.min(1, t(validation.msg_en)) : validations.nullable());
                case "min_length":
                  return validations.min(validation.value, t(validation.msg_en));
                case "max_length":
                  return validations.max(validation.value, t(validation.msg_en));
                case "min_val":
                  return validations.min(validation.value, t(validation.msg_en));
                case "max_val":
                  return validations.max(validation.value, t(validation.msg_en));
                // Add more cases for other validation types as needed
                default:
                  return validations;
              }
            },
            getValidationType(field)
          );
          currentLevel[key] = fieldValidations;
        } else if (typeof currentLevel[key] !== 'object' || Array.isArray(currentLevel[key])) {
          throw new Error(`Conflict: The key "${key}" already exists and is not an object.`);
        }
      } else {
        if (!currentLevel[key]) {
          currentLevel[key] = {};
        } else if (typeof currentLevel[key] !== 'object' || Array.isArray(currentLevel[key])) {
          throw new Error(`Conflict: The key "${key}" already exists and is not an object.`);
        }
        currentLevel = currentLevel[key];

      }
    });

    return existingObject;
  }

  const getValidationType = (field: any) => {
    switch (field.field_type) {
      case 'select':
        return field.field_properties?.is_multiselect
          ? yup.array()
          : yup.string()

      case 'number':
      case 'currency':
        return yup.number().transform((value, originalValue) => (originalValue === '' ? undefined : value)).typeError('Please enter valid number').nullable()
      case 'currency_with_amount':
        return yup.number()
      case 'url':
        return yup.string().matches(/^(https?:\/\/)?((([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,})|localhost)(:\d{2,5})?(\/[a-zA-Z0-9#_-]+\/?)*(\?[a-zA-Z0-9&=_-]+)?(#\S+)?$/, { excludeEmptyString: true, message: "Please enter valid URL." })

      default:
        return yup.string()
    }
  }

  const convertNestedFieldSchemaObject = (nestedFields: any) => {
    const schema: any = {};

    for (const key in nestedFields) {
      if (typeof nestedFields[key] === 'object' && !Object.hasOwn(nestedFields[key], 'tests')) {
        schema[key] = yup.object().shape(convertNestedFieldSchemaObject(nestedFields[key]));
      } else {
        schema[key] = nestedFields[key]
      }
    }
    return schema;
  }


  const generateValidationSchema = (data: any[]) => {
    const yupSchemaObject: any = {};
    let nestedFielvalidations: any = {},
      nestedYupSchemaObj: any = {};

    data &&
      data?.forEach((field: any) => {
        let fieldValidations: any;
        if (field.validation && field.validation.length > 0) {
          if (field.name?.includes(".")) {
            nestedFielvalidations = convertToNestedObject(field.name, field, nestedFielvalidations);
          } else {
            fieldValidations = field.validation.reduce((validations: any, validation: any) => validationReducer(validations, validation, field, t),
              getValidationType(field)
            );
            yupSchemaObject[field.name] = fieldValidations;
          }

          nestedYupSchemaObj = convertNestedFieldSchemaObject(nestedFielvalidations)
        }

      });

    return yup.object().shape({
      [fieldArrayName]: yup.object().shape({ ...yupSchemaObject, ...nestedYupSchemaObj }),
    });
  };

  const {
    control,
    handleSubmit,
    formState,
    setValue,
    reset,
    getValues,
    watch,
    resetField,
    unregister,
    trigger,
    getFieldState,
    ...rest
  } = useForm({
    ...(defaultValues && typeof defaultValues === 'object' ? { defaultValues } : {}),
    resolver: yupResolver(generateValidationSchema(data)),
    mode: "all",
  });

  const { errors } = formState;

  const watchedValues = useWatch({
    control,
    name: fieldArrayName,
  });

  // Local States
  const [schema, setSchema] = useState<[]>([]);
  const [tabsData, setTabsData] = useState<any[]>([]);
  const [errorAlert, setErrorAlert] = useState<boolean>(false);
  const [currencyOption, setCurrencyOptions] = useState<string>('');
  const [isTabFormValid, setTabFormValid] = useState<boolean>(false);
  const [validateRequiredFields, setValidRequiredFields] = useState<any[]>([]);

  // Local Functions
  const handleTableAddClick = (tableName?: string) => {
    onTableAddClick?.(tableName)
  }

  const getSectionData = useCallback((section: any) => {
    const sectionMembers = section?.members?.map((ele: any) => ele) || []
    const values = getValues(fieldArrayName)
    const isFormSwitcher = section.section_type === SECTION_TYPES.FORM_SWITCH_SECTION
    const formSwitcherName =
      section?.form_switcher_name ||
      section?.form_switcher_label?.toLowerCase().split(" ").join("_");
    const switchForms = section?.switcher_forms?.map((form: any) => ({
      ...form,
      formMembers: sectionMembers.filter(
        (member: any) => member.section_form_id === form.id,
      )
    }));
    const selectedSectionForm =
      values?.[formSwitcherName] ?
        switchForms.find((ele: any) =>
          ele.name === values?.[formSwitcherName]
        ) : {};

    // When form switcher is active, include:
    // 1. Common fields (fields without section_form_id or is_form_switcher_section)
    // 2. Form-specific fields (fields with section_form_id matching the selected form)
    let members;
    if (isFormSwitcher) {
      const commonFields = sectionMembers.filter(
        (member: any) => !member.section_form_id && !member.is_form_switcher_section
      );
      const formSpecificFields = selectedSectionForm?.formMembers || [];
      members = [...commonFields, ...formSpecificFields];
    } else {
      members = section?.members;
    }

    return {
      isFormSwitcher,
      formSwitcherName,
      switchForms,
      selectedSectionForm,
      members,
      values
    }
  }, [fieldArrayName, getValues])

  const handleSetCountryCodeField = useCallback((country: CountryData, field: any, fieldArrayName: any, values: any) => {
    const oldVal = values?.[fieldArrayName]?.[field?.country_code_field_name]
    const newVal = `+${country.dialCode}`
    if (
      field?.is_country_code_separate &&
      field?.country_code_field_name &&
      oldVal !== newVal
    ) {
      setValue(
        `${fieldArrayName}.${field?.country_code_field_name}` as never,
        newVal as never
      )
    }
  }, [setValue])

  const handleFieldCleanUp = useCallback((switchForms: any) => {
    switchForms.forEach((form: any) => {
      form?.formMembers.forEach((member: any) => {
        const memberName = member?.name || member.label.toLowerCase().split(" ").join("_")
        const v = _.get(defaultValues, `${fieldArrayName}.${memberName}`, null)
        const newData = data.map((ele: any) => {
          if (member?.section_form_id === ele?.section_form_id) {
            delete ele.value
          }
          return ({
            ...ele,
            ...(v ? { value: v } : {}),
          })
        })
        if (!v) {
          resetField(`${fieldArrayName}.${memberName}` as never)
          unregister(`${fieldArrayName}.${memberName}` as never)
        }
        setFields?.(newData)
      })

    })
  }, [data, defaultValues, fieldArrayName, resetField, setFields, unregister])

  const createNestedObjectFromDot = useCallback((dotNotationString: string, field: any, existingObject: any = {}) => {
    const keys = dotNotationString.split('.');
    let currentLevel = existingObject;

    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        if (!currentLevel[key]) {
          let fieldValue = field.value
          if (fieldValue && (field.field_type !== 'image' || field.field_type !== 'file')) {
            if (field.field_type === 'date') {
              fieldValue = dayjs(fieldValue)
            } else if (field.field_type === 'time') {
              const [hours, minutes, seconds] = fieldValue.split(":").map(Number);
              fieldValue = dayjs().set('hour', hours).set('minute', minutes).set('second', seconds).set('millisecond', 0)
            } else if (field.name.includes('_id') && !Array.isArray(field?.value)) {
              fieldValue = Number(fieldValue)
            }
          }
          currentLevel[key] = fieldValue;
        } else if (typeof currentLevel[key] !== 'object' || Array.isArray(currentLevel[key])) {
          throw new Error(`Conflict: The key "${key}" already exists and is not an object.`);
        }
      } else {
        if (!currentLevel[key]) {
          currentLevel[key] = {};
        } else if (typeof currentLevel[key] !== 'object' || Array.isArray(currentLevel[key])) {
          throw new Error(`Conflict: The key "${key}" already exists and is not an object.`);
        }
        currentLevel = currentLevel[key];

      }
    });

    return existingObject;
  }, [])

  const removeMatchingKeyValuePairs = useCallback((obj1, obj2) => {
    _.forOwn(obj1, (value, key) => {
      if (_.has(obj2, key) && _.isEqual(value, obj2[key])) {
        delete obj1[key];
      }
    });
    return obj1;
  }, [])

  const validateRequiredSwitchFormData = useCallback((switchData: any) => {
    const requiredFields: string[] = [];
    if (switchData) {
      switchData && switchData[0]?.formMembers.forEach((member: any) => {
        if (member?.validation && Array.isArray(member?.validation)) {
          member?.validation.forEach((validation: any) => {
            if (validation?.thenValidations && Array.isArray(validation?.thenValidations)) {
              validation?.thenValidations.forEach((thenValidation: any) => {
                if (thenValidation?.type === "required" && thenValidation?.value === true) {
                  if (member?.name) {
                    requiredFields.push(member.name);
                  }
                }
              });
            } else {
              const hasRequiredValidation = member.validation.some(
                (validation: any) => validation.type === 'required' && validation.value === true
              )
              if (hasRequiredValidation) {
                requiredFields.push(member.name);
              }
            }
          });
        }
      });

    }
    if (requiredFields) {
      setValidRequiredFields(_.uniq(requiredFields))
    }

  }, [])

  const isEmpty = useCallback((value: any): boolean => {
    return (
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'object' && Object.keys(value).length === 0)
    );
  }, [])

  const getMissingFields = useCallback((watchedFields: any, validationReqFields: string[]): string[] => {
    const missingFields: string[] = [];

    validationReqFields.forEach((fieldPath) => {
      const keys = fieldPath.split(".");
      let currentLevel = watchedFields;

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];

        if (!currentLevel?.[key] && currentLevel?.[key] !== 0) {
          // If any key in the path is missing, mark the field as missing
          missingFields.push(fieldPath);
          return;
        }

        // Move deeper into the object
        currentLevel = currentLevel[key];
      }

      // After navigating the full path, check if the final value is empty
      if (isEmpty(currentLevel)) {
        missingFields.push(fieldPath);
      }
    });


    return missingFields;
  }, [isEmpty])

  // Use Effects
  useEffect(() => {
    if (recieveTabDataLenght) {
      recieveTabDataLenght(tabsData.length)
    }
  }, [recieveTabDataLenght, tabsData])

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.origin) {
        return;
      }
      const { state } = event.data;

      if (state?.length) {
        const data: any = formBuilderDeConversion(state);

        if (data.tab) {
          setTabsData(data.tab);
        } else if (data.section) {
          setSchema(data.section);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    if (data) {
      const formData = formBuilderDeConversion(data)
      if (formData?.tab) {
        // setSchema([])
        setTabsData(formData.tab);
        if (activeTab !== undefined) {
          setSchema(formData.tab[activeTab]?.data || []);
        }
      } else {
        setSchema(formData.section);
        // setTabsData([])
      }
      const dVals = _.get(defaultValues, fieldArrayName, {})
      const wVals = removeMatchingKeyValuePairs((watchedValues || {}), (dVals || {}))
      if (mode === 'edit' && !Object.keys(wVals)?.length) {
        let formValues: any = {};
        let nestedFormValues: any = {};
        data.forEach((field: any) => {
          const fieldValue = field.value
          if (field.name?.includes(".")) {
            nestedFormValues = createNestedObjectFromDot(field.name, field, nestedFormValues)
          } else {
            if (fieldValue && (field.field_type !== 'image' || field.field_type !== 'file')) {
              if (field?.is_section_field) {
                const fieldName = field?.form_switcher_name || field?.form_switcher_label;
                formValues = { ...formValues, [fieldName]: fieldValue }
              } else if (
                field?.name &&
                ['company_id', 'email_ids'].includes(field?.name) &&
                ['edit_customer', 'add_customer', 'edit_vendor', 'add_vendor'].includes(fieldArrayName)
              ) {
                formValues = { ...formValues, [field.name]: fieldValue }
              } else if (field.field_type === 'date') {
                formValues = { ...formValues, [field.name]: dayjs(fieldValue) }
              } else if (field.field_type === 'time') {
                const [hours, minutes, seconds] = fieldValue.split(":").map(Number);
                formValues = { ...formValues, [field.name]: dayjs().set('hour', hours).set('minute', minutes).set('second', seconds).set('millisecond', 0) }
              } else if (field.name.includes('_id') && !Array.isArray(field?.value)) {
                if (fieldArrayName === "edit_user" && field.name === "role_id") {
                  formValues = { ...formValues, [field.name]: fieldValue }
                } else {
                  formValues = { ...formValues, [field.name]: Number(fieldValue) }
                }
              } else {
                formValues = { ...formValues, [field.name]: fieldValue }
              }
            }
          }
        })
        const finalFormValues = { ...formValues, ...nestedFormValues }
        reset({ [fieldArrayName]: { ...finalFormValues } })
      }
      getFormMethods?.({ control, handleSubmit, setValue, reset, resetField, getValues, unregister, trigger, watch, getFieldState, errors, ...rest })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (activeTab?.toString()) {
      if (tabsData && tabsData[activeTab]) {
        setSchema(tabsData[activeTab].data);
      }
    }
  }, [activeTab, tabsData]);

  useEffect(() => {
    if (watchedValues && handleFormValues) {
      handleFormValues?.(watchedValues);
    }
  }, [handleFormValues, watchedValues])

  useEffect(() => {
    if (errors?.[fieldArrayName]) {
      setErrorAlert(true)
    } else {
      setErrorAlert(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldArrayName, JSON.stringify(errors)])

  useEffect(() => {
    const validatedFields: string[] = [];
    if (activeTab != undefined) {
      tabsData[activeTab]?.data.forEach((section: any) => {

        if (section.members && Array.isArray(section.members)) {

          section.members.forEach((member: any) => {
            if (member.validation && Array.isArray(member.validation)) {
              const hasRequiredValidation = member.validation.some(
                (validation: any) => validation.type === 'required' && validation.value === true
              )
              if (hasRequiredValidation) {
                // validatedFields.push(fieldArrayName + '.' + member.name);
                validatedFields.push(member.name);
              }
            }
          });
        }
      })
      setValidRequiredFields(validatedFields);
    }
  }, [tabsData, activeTab]);

  useEffect(() => {
    if (watchedValues?.account_type) {

      const switchFormData: any[] = [];
      schema && schema.forEach((section: any) => {
        const sectionMembers = schema && section?.members?.map((ele: any) => ele) || [];

        const switchForms = schema && section?.switcher_forms?.map((form: any) => ({
          ...form,
          formMembers: sectionMembers.filter(
            (member: any) => member.section_form_id === form.id,
          ),
        }));
        if (switchForms) {
          switchFormData.push(switchForms)
        }
      })

      const selectValue = watchedValues?.account_type || "Individual";
      const switchData = switchFormData && Array.isArray(switchFormData[0])
        ? switchFormData[0].filter((form: any) => form.name === selectValue)
        : [];

      if (switchData) {
        validateRequiredSwitchFormData(switchData)
      }

    }
  }, [watchedValues?.account_type, schema, validateRequiredSwitchFormData]);

  useEffect(() => {
    if (validateRequiredFields.length > 0) {
      const updatedRequiredFields = getMissingFields(watchedValues, validateRequiredFields)

      // const updatedRequiredFields = validateRequiredFields.filter((fieldPath) => {
      //   const watchedValue = watchedFields[fieldPath] ;
      //   return watchedValue === undefined || watchedValue === null  || watchedValue === 0  ;
      // });

      updatedRequiredFields.length === 0 ? setTabFormValid(true) : setTabFormValid(false);
    } else {
      setTabFormValid(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateRequiredFields, watchedValues, activeTab])

  useEffect(() => {
    if (recieveIsValidForm) {
      recieveIsValidForm(isTabFormValid)
    }
  }, [recieveIsValidForm, isTabFormValid])


  return (
    // <FullScreenLayout>
    <Box sx={{ width: "100%", padding: "2rem", ...containerStyles }}>
      <FormProvider {...{ control, handleSubmit, setValue, reset, resetField, getValues, unregister, trigger, watch, errors, getFieldState, formState, ...rest }}>
        <form id={fieldArrayName} name={fieldArrayName} onSubmit={handleSubmit(handleFormSubmit)}>
          {Boolean(tabsData?.length) && (
            <>
              {errorAlert &&
                <Alert severity='error' onClose={() => setErrorAlert(false)}>
                  Please fill all the required fields.
                </Alert>
              }
              <TabBar
                tabs={tabsData}
                activeTabs={activeTabs}
                activeValue={activeTab}
                setActiveValue={setActiveTabValue}
                isFormTabValid={isTabFormValid}
              />
            </>
          )}
          {schema &&
            schema.map((section: any, index: number) => {
              const {
                isFormSwitcher,
                formSwitcherName,
                switchForms,
                members,
                values,
              } = getSectionData(section)

              return (
                <FormSection
                  section={section}
                  index={index}
                  members={members}
                  switchForms={switchForms}
                  isFormSwitcher={isFormSwitcher}
                  control={control}
                  fieldArrayName={fieldArrayName}
                  formSwitcherName={formSwitcherName}
                  displayAvtar={displayAvtar}
                  isButton={isButton}
                  currencyOption={currencyOption}
                  values={values}
                  onBlur={onBlur}
                  setValue={setValue}
                  onSelectFooterClick={onSelectFooterClick}
                  getSelectedData={getSelectedData}
                  setCurrencyOptions={setCurrencyOptions}
                  refreshOptions={refreshOptions}
                  handleFieldCleanUp={handleFieldCleanUp}
                  handleSetCountryCodeField={handleSetCountryCodeField}
                  handleTableAddClick={handleTableAddClick}
                  onTableCellChange={onTableCellChange}
                  // setDetailsData={setDetailsData}
                  t={t}
                  images={images}
                />
              );
            })}
        </form>
      </FormProvider>
    </Box>
    // </FullScreenLayout>
  );
};

export default FormParser;
